import { all, call, put, select, take, takeLeading } from 'redux-saga/effects';

import { waitForCartLoading } from '@elab/core/utils/cart/sagaHelpers';
import {
    actions as storeActions,
    selectors as storeLocatorSelectors,
    types as storeTypes,
} from '@elab/core/store/store-locator';
import { actions as uiActions } from '@elab/core/store/ui';
import { actions as cartActions, selectors as cartSelectors } from '@elab/core/store/cart';
import { actions as checkoutActions } from '@elab/core/store/checkout';
import { actions as deliveryActions } from '@elab/components/connected/DeliveryModes/redux';
import * as storage from '@elab/core/utils/storage';

import actions from './actions';
import types from './types';
import api from './api';

const PICKUP_MODAL_NAME = 'pickup-modal';

export function* initialize() {
    yield call(waitForCartLoading);
    yield put(actions.loadProvinces());
}

export function* loadProvinces() {
    try {
        const data = yield call(api.getProvinces);
        yield put(actions.setProvinces(data));
    } catch (e) {
        yield put(actions.setProvinces([]));
    }
}

export function* setProvince({ payload }) {
    if (!payload) {
        yield put(actions.setTowns([]));
        return;
    }

    try {
        const data = yield call(api.getTowns, payload);
        yield put(actions.setTowns(data));
    } catch (e) {
        yield put(actions.setTowns([]));
    }
}

export function* setTown({ payload }) {
    if (!payload) return;

    try {
        yield put(storeActions.getStoresByTown(payload));
        yield take(storeTypes.SET_STORES_DATA);
        yield put(uiActions.openDialog({ name: PICKUP_MODAL_NAME }));
        yield put(actions.resetSelections());
    } catch (e) {
        /* Nothing */
    }
}

export function* setStore({ payload = {} }) {
    const { storeId } = payload;
    const deliveryModeId = yield select(cartSelectors.getDeliveryModeCode);
    const pointsOfServices = yield select(storeLocatorSelectors.getStores);
    const { geoPoint } = pointsOfServices.find(({ name }) => name === storeId) || {};

    try {
        yield all([
            put(deliveryActions.setDeliveryMode({ deliveryModeId, storeId })),
            put(uiActions.closeDialogByName(PICKUP_MODAL_NAME)),
        ]);
        yield put(checkoutActions.setChangeDeliveryAddress({ status: false }));
        yield call(storage.set, storage.key.ccTraditionalDeliveryAddress, geoPoint, true);
        yield put(cartActions.loadCCTraditionalDeliveryDate({ code: deliveryModeId }));
    } catch (e) {
        /* Nothing */
    }
}

export default () => [
    takeLeading(types.LOAD_PROVINCES, loadProvinces),
    takeLeading(types.SET_PROVINCE, setProvince),
    takeLeading(types.SET_TOWN, setTown),
    takeLeading(types.SET_STORE, setStore),
    takeLeading(types.INITIALIZE, initialize),
];
